import {Component, Input} from "@angular/core";
import {ModalController} from "@ionic/angular";

@Component({
  selector: "app-site-create",
  templateUrl: "./site-create-success.component.html",
  standalone: false,
})
export class SiteCreateSuccessComponent {

  @Input() public token!: string;

  constructor(private modalCtrl: ModalController) {
  }

  confirm() {
    this.modalCtrl.dismiss();
  }

}
